import { render, staticRenderFns } from "./DefaultPackage.vue?vue&type=template&id=7633f554&"
import script from "./DefaultPackage.vue?vue&type=script&lang=js&"
export * from "./DefaultPackage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports